import { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  MenuItem,
  Select,
  Button,
} from "@mui/material";
import { EditPage, getPageDetails } from "../../Services/ExperienceApi";
import { toast, ToastContainer } from "react-toastify";
import Grid from "@mui/material/Grid2";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import { ReactComponent as UrlIcon } from "../../Assets/urlicon.svg";
import { ReactComponent as CrossIcon } from "../../Assets/cross.svg";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const ContentCard = () => {
  const [formData, setFormData] = useState<any>({
    title: "Page",
    urls: [],
    urlParameters: [],
    zones: [],
    contentAuthor: [],
    tags: [],
    contentSection: [],
  });

  const [disableFields, setDisableFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newValues, setNewValues] = useState<{ [key: string]: string }>({});
  const [isToggle, setIsToggle] = useState<"all" | "any">("any");
  const location = useLocation();
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const page = location.state?.data.id || sessionObj.pageId;
  const fullpageId = page;
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  const pageId = fullpageId?.split("_")[1] || sessionObj.pageId;
  const navigate = useNavigate();
  const [titleError, setTitleError] = useState(false);
  const handleAddItem = (key: string, value: string) => {
    const newValue = value.trim();
    if (!newValue) return;
    const existingList = Array.isArray(formData[key]) ? formData[key] : [];
    const filteredList = existingList.filter(
      (item: any) => item.value.toLowerCase() !== newValue.toLowerCase()
    );

    setFormData((prev: any) => ({
      ...prev,
      [key]: [...filteredList, { value: newValue }],
    }));
    setNewValues((prev: any) => ({ ...prev, [key]: "" }));
  };

  const handleRemoveItem = (key: any, index: any) => {
    if (disableFields) return;
    const updatedList = formData[key].filter((_: any, i: any) => i !== index);
    setFormData({ ...formData, [key]: updatedList });
  };
  const fetchPageDetails = async () => {
    if (pageId === "default" || !pageId) return;
    try {
      const response = await getPageDetails(experienceId);
      const data = response?.page_settings || [];
      if (data.length > 0) {
        const pageData = data[0];

        const normalize = (fieldData: any) => {
          const result: { value: string; type: "include" | "exclude" }[] = [];

          if (fieldData?.include && Array.isArray(fieldData.include)) {
            result.push(
              ...fieldData.include.map((val: string) => ({
                value: val,
                type: "include",
              }))
            );
          }

          if (fieldData?.exclude && Array.isArray(fieldData.exclude)) {
            result.push(
              ...fieldData.exclude.map((val: string) => ({
                value: val,
                type: "exclude",
              }))
            );
          }

          return result;
        };
        setDisableFields(!!pageData.target_all_pages);
        setFormData({
          title: pageData.title,
          urls: normalize(pageData.urls),
          urlParameters: normalize(pageData.url_parameters),
          zones: normalize(pageData.zones),
          contentAuthor: normalize(pageData.content_author),
          tags: normalize(pageData.tags),
          contentSection: normalize(pageData.content_section),
        });
        setIsToggle(pageData.match_type);
      }
    } catch (error) {
      console.error("Error fetching experience data:", error);
    }
  };
  useEffect(() => {
    fetchPageDetails();
  }, [pageId]);

  const handleSave = async () => {
    if (!formData.title.trim()) {
      setTitleError(true);
      return;
    }

    try {
      setLoading(true);
      const extractValues = (items: any[], type: "include" | "exclude") => {
        if (!Array.isArray(items)) return [];
        return items
          .filter((item) => (item?.type || "include") === type)
          .map((item) => item?.value || "");
      };

      const payload: any = {
        target_all_pages: disableFields,
        title: formData.title.trim(),
      };

      if (!disableFields) {
        // payload.match_type = isToggle;
        const optionalFields = {
          urls: formData.urls,
          url_parameters: formData.urlParameters,
          tags: formData.tags,
          zones: formData.zones,
          content_author: formData.contentAuthor,
          content_section: formData.contentSection,
        };
        const allOptionalFieldsEmpty = Object.values(optionalFields).every(
          (val: any[]) => !val || val.length === 0
        );

        payload.target_all_pages = disableFields || allOptionalFieldsEmpty;
        const processedFields: any = {};
        if (!allOptionalFieldsEmpty) {
          payload.match_type = isToggle || "any";
        }

        Object.entries(optionalFields).forEach(([key, value]) => {
          const includeValues = extractValues(value as any[], "include");
          const excludeValues = extractValues(value as any[], "exclude");

          if (includeValues.length || excludeValues.length) {
            processedFields[key] = {
              ...(includeValues.length && { include: includeValues }),
              ...(excludeValues.length && { exclude: excludeValues }),
            };
          }
        });

        if (Object.keys(processedFields).length) {
          Object.assign(payload, processedFields);
        }
      }
      const response = await EditPage(experienceId, payload);
      if (response && !response.error) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTypeChange = (key: string, index: number, newType: string) => {
    setFormData((prev: any) => {
      const updatedItems = [...prev[key]];
      updatedItems[index] = { ...updatedItems[index], type: newType };
      return { ...prev, [key]: updatedItems };
    });
  };
  const handleToggle = () => {
    setIsToggle((prev: any) => (prev === "all" ? "any" : "all"));
  };
  const onback = () => {
    navigate(`/edit-experience/${experienceId}`);
  };

  return (
    <>
      <div className="templates">
        {/* Header Section */}
        <Grid container className="templates__header ">
          <Grid
            size={{ xs: 12, md: 2, sm: 3 }}
            className="templates__header--search"
          >
            <div className="d-center">
              <span className="Icon">
                <IconButton aria-label="close">
                  <ArrowbackIcon onClick={onback} />
                </IconButton>
              </span>{" "}
              <h2> Page</h2>
            </div>
          </Grid>

          <Grid
            size={{ xs: 12, md: 8, sm: 5 }}
            className="templates__header--search checkbox-heading"
          >
            <div className="switch-wrapper">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={disableFields}
                  onChange={() => setDisableFields(!disableFields)}
                />
                <span className="slider"></span>
              </label>
            </div>
            <Typography>Target all pages</Typography>
          </Grid>
          <Grid
            size={{ xs: 12, md: 2, sm: 4 }}
            className="templates__header--button"
          >
            <Box className="button-heading">
              <Button
                className="button"
                sx={{
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "&:hover": {
                    "--variant-containedBg": "rgba(228, 0, 43, 1)",
                    "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                  },
                }}
                variant="contained"
                color="error"
                onClick={handleSave}
                disabled={loading}
              >
                {loading ? <span className="loader" /> : "Save"}
              </Button>
              <Button
                sx={{
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",

                  "&:hover": {
                    "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                    "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                    "--variant-containedBg": "rgba(228, 0, 43, 1)",
                    "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                  },
                }}
                variant="outlined"
                onClick={onback}
              >
                Cancel
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
      {/* Card Section */}
      <Box className="cardEditpage" mt={2}>
        <div className="cardEditpage__header  ">
          <Grid container className="">
            <Grid size={{ xs: 12, md: 2, sm: 12 }}>
              <h4>TITLE OF CARD :</h4>
            </Grid>
            <Grid size={{ xs: 12, md: 10, sm: 12 }}>
              <TextField
                variant="standard"
                placeholder="Title here"
                fullWidth
                value={formData.title}
                error={titleError}
                helperText={titleError ? "Title is required" : ""}
                onChange={(e) => {
                  const title = e.target.value;
                  setFormData({ ...formData, title });
                  if (title.trim()) {
                    setTitleError(false); // clear error when typing valid value
                  }
                }}
              />
            </Grid>
          </Grid>
        </div>

        <div className="cardEditpage__content">
          <Grid container className="" mb={2}>
            <Grid size={{ xs: 12, md: 6, sm: 12 }}>
              <h4>Content and url parameters</h4>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              justifyContent="end"
              display="flex"
              alignItems="center"
            >
              <Typography mr={1} variant="body1">
                Any One Of
              </Typography>

              <div className="switch-wrapper">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isToggle === "all"}
                    onChange={handleToggle}
                    disabled={disableFields}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              <Typography ml={1} variant="body1">
                All Of
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={4} mt={2}>
            {[
              { key: "urls", label: "URLs" },
              { key: "urlParameters", label: "URL Parameters" },
              { key: "tags", label: "Tags" },
              { key: "zones", label: "Zones" },
              { key: "contentAuthor", label: "Content Author" },
              { key: "contentSection", label: "Content Section" },
            ].map(({ key, label }) => (
              <Grid
                key={key}
                size={{ xs: 12, md: 4, sm: 12 }}
                className="cardEditpage__content--main"
              >
                <Typography variant="subtitle1" p={2}>
                  <span className="Icon">
                    <UrlIcon />
                  </span>{" "}
                  {label}
                </Typography>

                {/* List of Added Items */}
                <div className="cardEditpage__content--box">
                  {Array.isArray(formData[key]) &&
                    formData[key].map((item: any, index: any) => (
                      <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        gap={1}
                        mb={1}
                      >
                        <TextField
                          variant="standard"
                          fullWidth
                          value={item.value}
                          disabled
                        />
                        <Select
                          value={item.type || "include"}
                          onChange={(e: any) =>
                            handleTypeChange(key, index, e.target.value)
                          }
                          size="small"
                          variant="standard"
                          disabled={disableFields}
                        >
                          <MenuItem value="include">Include</MenuItem>
                          <MenuItem value="exclude">Exclude</MenuItem>
                        </Select>
                        <IconButton
                          size="small"
                          className="Icon"
                          onClick={() => handleRemoveItem(key, index)}
                        >
                          <CrossIcon fontSize="medium" />
                        </IconButton>
                      </Box>
                    ))}
                </div>
                {/* Input Field for Adding New Items */}
                <Box className="cardEditpage__content--footer">
                  <TextField
                    variant="standard"
                    fullWidth
                    placeholder={`Add ${label}...`}
                    value={newValues[key] || ""}
                    onChange={(e) =>
                      setNewValues({ ...newValues, [key]: e.target.value })
                    }
                    onKeyPress={(e) => {
                      if (e.key === "Enter" && newValues[key]?.trim()) {
                        handleAddItem(key, newValues[key].trim());
                      }
                    }}
                    disabled={disableFields}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </div>
      </Box>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default ContentCard;
